// volto-home — tenant addon for ljusa-tider.se, the platform's apex landing
// page (DR-2026-314). Tells the platform story language-first (Polyglot is
// the project from the outset — PLATFORM_VISION "Why Language is THE
// Foundation"); carries the fleet-logo footer per the DR-2026-314 consent
// register (Phase 3).
//
// Deliberately minimal at v0.1.0: en only over the converged VLT-8 baseline.
// The operator has declared the landing will update frequently and go
// multilingual when bandwidth allows — isMultilingual stays true so language
// roots are additive; content updates flow through the corpus-owned
// md→fixture→apply pipeline.

import { applyTenantBaseline } from 'volto-tenant-baseline/applyTenantBaseline';
import HomeColophon from './components/HomeColophon';

const NullSlot = () => null;

const applyConfig = (config) => {
  config.settings.supportedLanguages = ['en'];
  config.settings.defaultLanguage = 'en';
  config.settings.isMultilingual = true;

  // Fleet baseline (CR-2026-077 / volto-tenant-baseline): token-truth
  // UserTools, native-name LanguageSelector, 880px content-width token.
  config = applyTenantBaseline(config, { tenantKey: 'home' });

  // Footer: LT colophon over VLT's Plone default (DR-2026-248 slot pattern,
  // guides/ekonomi precedent). The DR-2026-314 Phase-3 partner-logo row rides
  // VLT's NATIVE FooterLogos slot (preFooter), driven by the
  // voltolighttheme.footer behavior's footer_logos data on each Languageroot —
  // so that slot must NOT be nulled here (the guides-lineage null was the
  // s572→s573 render blocker after the behavior data landed).
  config.registerSlotComponent({ slot: 'postFooter', name: 'PostFooterFollowUsLogoAndLinks', component: NullSlot });
  config.registerSlotComponent({ slot: 'postFooter', name: 'Colophon', component: HomeColophon });

  return config;
};

export default applyConfig;
